
import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import { SmartImage, SmartImageProps } from "_components";
import { generateID } from "_utils";
import { PARAMS, Curtains, Plane } from "./shaders";
import { WPImage } from "_types";

const INTERVAL = 10000;

@Component({
  name: "EventTakeoverBackgroundGallery",
  components: { SmartImage },
})
export default class EventTakeoverBackgroundGallery extends Vue {
  rootClass = "p-event-background";
  @Prop() images: SmartImageProps[];
  @Prop() displacement: WPImage;

  @Ref() canvas: HTMLElement;
  @Ref() plane: HTMLElement;

  webGLcurtain = null;
  webGLplane = null;
  slideshowState = null;
  activeTex = null;
  nextTex = null;
  interval = null;

  loadCounter = 0;
  loaded = false;

  handleLoad() {
    if (this.loaded) return;

    this.loadCounter += 1;
    if (this.loadCounter === this.images.length + 1) {
      this.loaded = true;

      setTimeout(() => this.init(), 100);
    }
  }

  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
      //   this.setupListeners(false);
      this.webGLcurtain.dispose();
    }
  }

  get ID() {
    return generateID();
  }

  private next() {
    const {
      slideshowState: state,
      activeTex,
      nextTex,
      webGLcurtain,
      webGLplane,
    } = this;
    if (!state.isChanging && activeTex && nextTex) {
      webGLcurtain.enableDrawing();
      state.isChanging = true;

      if (state.activeTextureIndex < state.maxTextures) {
        state.nextTextureIndex = state.activeTextureIndex + 1;
      } else {
        state.nextTextureIndex = 1;
      }

      nextTex.setSource(webGLplane.images[state.nextTextureIndex]);
      state.transitionTimer = 0;
      this.transition();
    }
  }

  private transition() {
    const { slideshowState: state, activeTex, webGLplane, webGLcurtain } = this;

    if (state.transitionTimer < 90) {
      state.transitionTimer += 0.6;
      requestAnimationFrame(() => this.transition());
    } else {
      webGLcurtain.disableDrawing();
      state.isChanging = false;
      state.activeTextureIndex = state.nextTextureIndex;

      if (state.activeTextureIndex < state.maxTextures) {
        state.nextTextureIndex = state.activeTextureIndex + 1;
      } else {
        state.nextTextureIndex = 1;
      }

      activeTex.setSource(webGLplane.images[state.activeTextureIndex]);
      state.transitionTimer = 0;
    }
  }

  public init() {
    this.webGLcurtain = new Curtains({
      container: this.canvas,
      watchScroll: false,
      pixelRatio: Math.min(1.5, window.devicePixelRatio),
      production: true,
    });

    this.slideshowState = {
      activeTextureIndex: 1,
      nextTextureIndex: 2,
      maxTextures: this.images.length,

      isChanging: false,
      transitionTimer: 0,
    };

    this.webGLcurtain.onContextLost(() => {
      this.webGLcurtain.restoreContext();
    });

    this.webGLcurtain.disableDrawing();

    this.webGLplane = new Plane(this.webGLcurtain, this.plane, PARAMS);

    this.webGLplane
      .onLoading((texture) => {
        texture.setMinFilter(this.webGLcurtain.gl.LINEAR_MIPMAP_NEAREST);
      })
      .onReady(() => {
        this.activeTex = this.webGLplane.createTexture({
          sampler: "activeTex",
          fromTexture:
            this.webGLplane.textures[this.slideshowState.activeTextureIndex],
        });
        this.nextTex = this.webGLplane.createTexture({
          sampler: "nextTex",
          fromTexture:
            this.webGLplane.textures[this.slideshowState.nextTextureIndex],
        });
        this.interval = setInterval(this.next, INTERVAL);
        this.$emit("isReady");
      })
      .onRender(() => {
        this.webGLplane.uniforms.transitionTimer.value =
          this.slideshowState.transitionTimer;
      });
  }

  // private next() {
  //   const {
  //     slideshowState: state,
  //     activeTex,
  //     nextTex,
  //     webGLcurtain,
  //     webGLplane,
  //   } = this;
  //   if (!state.isChanging && activeTex && nextTex) {
  //     webGLcurtain.enableDrawing();
  //     state.isChanging = true;

  //     if (state.activeTextureIndex < state.maxTextures) {
  //       state.nextTextureIndex = state.activeTextureIndex + 1;
  //     } else {
  //       state.nextTextureIndex = 1;
  //     }

  //     nextTex.setSource(webGLplane.images[state.nextTextureIndex]);

  //     setTimeout(() => {
  //       webGLcurtain.disableDrawing();
  //       state.isChanging = false;
  //       state.activeTextureIndex = state.nextTextureIndex;
  //       activeTex.setSource(webGLplane.images[state.activeTextureIndex]);
  //       state.transitionTimer = 0;
  //     }, Math.max(1700, window.innerWidth * 1.4));
  //   }
  // }

  // public init() {
  //   this.webGLcurtain = new Curtains({
  //     container: this.canvas,
  //     watchScroll: false,
  //     pixelRatio: Math.min(1.5, window.devicePixelRatio),
  //     production: true,
  //   });

  //   this.slideshowState = {
  //     activeTextureIndex: 1,
  //     nextTextureIndex: 2,
  //     maxTextures: this.images.length,

  //     isChanging: false,
  //     transitionTimer: 0,
  //   };

  //   this.webGLcurtain.onContextLost(() => {
  //     this.webGLcurtain.restoreContext();
  //   });

  //   this.webGLcurtain.disableDrawing();

  //   this.webGLplane = new Plane(this.webGLcurtain, this.plane, PARAMS);

  //   this.webGLplane
  //     .onLoading((texture) => {
  //       texture.setMinFilter(this.webGLcurtain.gl.LINEAR_MIPMAP_NEAREST);
  //     })
  //     .onReady(() => {
  //       this.activeTex = this.webGLplane.createTexture({
  //         sampler: "activeTex",
  //         fromTexture:
  //           this.webGLplane.textures[this.slideshowState.activeTextureIndex],
  //       });
  //       this.nextTex = this.webGLplane.createTexture({
  //         sampler: "nextTex",
  //         fromTexture:
  //           this.webGLplane.textures[this.slideshowState.nextTextureIndex],
  //       });
  //       this.interval = setInterval(this.next, INTERVAL);
  //       this.$emit("isReady");
  //     })
  //   .onRender(() => {
  //     const { slideshowState: state } = this;
  //     if (state.isChanging) {
  //       state.transitionTimer += (95 - state.transitionTimer) * 0.03;

  //       if (state.transitionTimer >= 94.9 && state.transitionTimer !== 95) {
  //         state.transitionTimer = 95;
  //       }
  //     }

  //     // update our transition timer uniform
  //     this.webGLplane.uniforms.transitionTimer.value = state.transitionTimer;
  //   });
  // }
}
